import { IDoorProps } from '@ovl/advent-cal/domain';
import css from 'classnames';
import React from 'react';
import './door.scss';

interface IProps {
  door: IDoorProps;
  animating: string;
  doAnimate: (doorId: string) => void;
  openDoor: (doorId: string) => void;
}

export const Door = ({ door, openDoor, animating, doAnimate }: IProps) => {
  const fadeOutBox = !!animating && animating !== door._id;
  const fadeDoorContent =
    door.prizeClaimed || (!!animating && animating === door._id);

  const onDoorClicked = () => {
    if (door.prizeClaimed) {
      openDoor(door._id);
    } else {
      doAnimate(door._id);

      // The timeout matches the animation time defined for CSS transitions
      setTimeout(() => {
        openDoor(door._id);
      }, 1500);
    }
  };

  return (
    <div
      className={css('ovl-adventDoor', {
        '-small': door.size === 'small',
        '-medium': door.size === 'medium',
        '-large': door.size === 'large',

        '-topSpaceSmall': door.topSpace === 'small',
        '-topSpaceMedium': door.topSpace === 'medium',
        '-topSpaceLarge': door.topSpace === 'large',
      })}
    >
      <div
        className="ovl-adventDoor__box"
        style={{ opacity: fadeOutBox ? 0 : 1 }}
      >
        <button className="ovl-adventDoor__trigger" onClick={onDoorClicked}>
          <span
            className="ovl-adventDoor__opened"
            style={{
              opacity: fadeDoorContent ? 1 : 0,
              backgroundImage: 'url(../../../assets/prize.jpg)',
            }}
          ></span>

          <span
            className="ovl-adventDoor__closed"
            style={{ opacity: fadeDoorContent ? 0 : 1 }}
          >
            <span>{door.number}</span>
          </span>
        </button>
      </div>
    </div>
  );
};

export default Door;
